import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-6 bg-gray-900/95 backdrop-blur-lg shadow-sm border-b border-gray-700/30">
      <div className="container max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <button 
            onClick={() => scrollToSection('home')}
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <img 
              src="/logo_justicai_laib_landing.png" 
              alt="Justiçai Logo" 
              className="h-[5rem] w-auto"
            />
          </button>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          <button 
            onClick={() => scrollToSection('home')}
            className="text-gray-300 hover:text-white font-medium transition-colors"
          >
            Início
          </button>
          <button 
            onClick={() => scrollToSection('how-it-works')}
            className="text-gray-300 hover:text-white font-medium transition-colors"
          >
            Como Funciona
          </button>
          <button 
            onClick={() => scrollToSection('pricing')}
            className="text-gray-300 hover:text-white font-medium transition-colors"
          >
            Planos
          </button>
          <button 
            onClick={() => scrollToSection('casos-features')}
            className="text-gray-300 hover:text-white font-medium transition-colors"
          >
            Recursos
          </button>
          <Link 
            to="/docs"
            className="text-gray-300 hover:text-white font-medium transition-colors"
          >
            Documentação
          </Link>
          <button 
            onClick={() => scrollToSection('benefits')}
            className="text-gray-300 hover:text-white font-medium transition-colors"
          >
            Benefícios
          </button>
          <button 
            onClick={() => scrollToSection('pricing')}
            className="bg-primary text-white px-6 py-2 rounded-lg font-medium hover:bg-primary/90 transition-colors"
          >
            Começar Agora
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-300 p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-gray-900/95 backdrop-blur-lg border-b border-gray-700/30 md:hidden">
            <div className="container mx-auto px-6 py-4 space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="block w-full text-left text-gray-300 hover:text-white font-medium transition-colors py-2"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('how-it-works')}
                className="block w-full text-left text-gray-300 hover:text-white font-medium transition-colors py-2"
              >
                Como Funciona
              </button>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="block w-full text-left text-gray-300 hover:text-white font-medium transition-colors py-2"
              >
                Planos
              </button>
              <button 
                onClick={() => scrollToSection('casos-features')}
                className="block w-full text-left text-gray-300 hover:text-white font-medium transition-colors py-2"
              >
                Recursos
              </button>
              <Link 
                to="/docs"
                className="block w-full text-left text-gray-300 hover:text-white font-medium transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Documentação
              </Link>
              <button 
                onClick={() => scrollToSection('benefits')}
                className="block w-full text-left text-gray-300 hover:text-white font-medium transition-colors py-2"
              >
                Benefícios
              </button>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="block w-full bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors mt-4"
              >
                Começar Agora
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;